import { render, staticRenderFns } from "./event-page-donations-item.vue?vue&type=template&id=156528be&scoped=true&"
import script from "./event-page-donations-item.vue?vue&type=script&lang=js&"
export * from "./event-page-donations-item.vue?vue&type=script&lang=js&"
import style0 from "./event-page-donations-item.vue?vue&type=style&index=0&id=156528be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156528be",
  null
  
)

export default component.exports